const backdropClass = 'c-backdrop';
const backdropOpenClass = backdropClass + '--open';

const backdropJsClass = 'js-backdrop';

const backdropElement = document.querySelector('.' + backdropJsClass) as HTMLElement;

if (backdropElement) {
    // Add custom event listeners
    document.addEventListener('openBackdrop', () => {
        openBackdrop();
    });

    document.addEventListener('closeBackdrop', () => {
        closeBackdrop();
    });

    // Add click event listener to close the menu
    backdropElement.addEventListener('click', () => {
        // Dispatch custom event to close large menu
        document.dispatchEvent(new CustomEvent('closeMenuLarge'));
    });
}

function openBackdrop () {
    if (!backdropElement) {
        return;
    }

    // Add the active class to the backdrop
    backdropElement.classList.add(backdropOpenClass);
}

function closeBackdrop () {
    if (!backdropElement) {
        return;
    }

    // Remove the active class to the backdrop
    backdropElement.classList.remove(backdropOpenClass);
}